module.exports = __webpack_public_path__ + "img/icon6.72ce690.png";